export default {
    authenticationRedirect: {
        path: '/authentication-redirect',
        name: 'authenticationRedirect',
        meta: {
            title: '统一认证'
        },
        component: () => import('./index.vue')
    }
};
